import React, { useState } from 'react';
import { Button, Form, FormGroup, Label } from "reactstrap";
import MyEditor from "../Editor/index.jsx";

const CommentForm = (props) => {
  const [text, setText] = useState(props.initialText || "");

  const onSubmit = (event) => {
    event.preventDefault();
    if (props.submitLabel == "Update") {
      console.log("updating");
      props.handleUpdate(text);
    } else if (props.submitLabel == "Reply") {
      props.handleReply(text);
    } else if (props.submitLabel == "Quote") {
      props.handleReply(text);
    } else {
      props.handleSubmit(text);
    }
    setText("");
  };

  return (
    <Form onSubmit={onSubmit}>
      <FormGroup>
        {props.submitLabel == "Submit" && (
          <Label for="description">Write Comment</Label>
        )}
        <MyEditor
          initialContent={text}
          onChangeHandler={(newText) => setText(newText)}
        />
      </FormGroup>
      <Button className="mr-2" color="primary">
        {props.submitLabel}
      </Button>
      {props.submitLabel != "Submit" && (
        <Button
          color="danger"
          className="mr-2"
          onClick={() => props.onCancel()}
        >
          Cancel
        </Button>
      )}
    </Form>
  );
};

export default CommentForm;
